import { render, staticRenderFns } from "./desktop-pagename.vue?vue&type=template&id=9e49f60a&scoped=true&"
import script from "./desktop-pagename.vue?vue&type=script&lang=ts&"
export * from "./desktop-pagename.vue?vue&type=script&lang=ts&"
import style0 from "./desktop-pagename.vue?vue&type=style&index=0&id=9e49f60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e49f60a",
  null
  
)

component.options.__file = "desktop-pagename.vue"
export default component.exports